import { render, staticRenderFns } from "./GalleryEditModal.vue?vue&type=template&id=23e4f1dc&scoped=true&"
import script from "./GalleryEditModal.vue?vue&type=script&lang=js&"
export * from "./GalleryEditModal.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditModal.vue?vue&type=style&index=0&id=23e4f1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4f1dc",
  null
  
)

export default component.exports